// frontend/src/components/Register.js
import React, { useState } from 'react';
import './Auth.css';

function Register({ onRegisterSuccess, switchToLogin }) {
  const [userName, setUserName] = useState('');
  const [mailAddress, setMailAddress] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleRegister = async () => {
    if (!userName || !mailAddress || !password || !confirmPassword) {
      setMessage('全ての項目を入力してください');
      return;
    }

    if (password !== confirmPassword) {
      setMessage('パスワードが一致しません');
      return;
    }

    try {
      const res = await fetch('/api/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userName, mailAddress, password }),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage('登録が完了しました。ログインしてください。');
        setTimeout(() => switchToLogin(), 1500);
      } else {
        setMessage(data.error || '登録に失敗しました');
      }
    } catch (error) {
      setMessage('通信エラーが発生しました');
      console.error(error);
    }
  };

  return (
    <div className="auth-container">
      <h2>新規ユーザー登録</h2>
      <input
        type="text"
        placeholder="ユーザー名"
        value={userName}
        onChange={(e) => setUserName(e.target.value)}
      />
      <input
        type="email"
        placeholder="メールアドレス"
        value={mailAddress}
        onChange={(e) => setMailAddress(e.target.value)}
      />
      <input
        type="password"
        placeholder="パスワード"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <input
        type="password"
        placeholder="パスワード（確認）"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
      <button onClick={handleRegister}>登録</button>
      {message && <p className="auth-message">{message}</p>}
      <p className="auth-switch" onClick={switchToLogin}>
        → ログイン画面へ戻る
      </p>
    </div>
  );
}

export default Register;
